import { render, staticRenderFns } from "./TotalizerBlock.vue?vue&type=template&id=ae5eb6c4&scoped=true"
import script from "./TotalizerBlock.vue?vue&type=script&lang=js"
export * from "./TotalizerBlock.vue?vue&type=script&lang=js"
import style0 from "./TotalizerBlock.vue?vue&type=style&index=0&id=ae5eb6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5eb6c4",
  null
  
)

export default component.exports